export default "__VITE_ASSET__0dz1frv$__"